import * as bootstrap from 'bootstrap';

(function () {
    window.bootstrap = window.bootstrap || bootstrap;

    function getBootstrap() {
        return window.bootstrap || {};
    }

    function isElement(value) {
        return value && value.nodeType === 1;
    }

    function resolveElement(target, root) {
        if (!target) {
            return null;
        }

        if (isElement(target)) {
            return target;
        }

        if (target[0] && isElement(target[0])) {
            return target[0];
        }

        if (typeof target !== 'string') {
            return null;
        }

        try {
            return (root || document).querySelector(target);
        } catch (e) {
            return null;
        }
    }

    function resolveElements(targets, root) {
        if (!targets) {
            return [];
        }

        if (typeof targets === 'string') {
            try {
                return Array.prototype.slice.call((root || document).querySelectorAll(targets));
            } catch (e) {
                return [];
            }
        }

        if (isElement(targets)) {
            return [targets];
        }

        if (targets[0] && isElement(targets[0])) {
            return Array.prototype.slice.call(targets);
        }

        return [];
    }

    function getInstance(componentName, target, options) {
        const Component = getBootstrap()[componentName];
        const element = resolveElement(target);

        if (!Component || !element) {
            return null;
        }

        if (typeof Component.getOrCreateInstance === 'function') {
            return Component.getOrCreateInstance(element, options || {});
        }

        return new Component(element, options || {});
    }

    function call(componentName, target, method, options) {
        const instance = getInstance(componentName, target, options);

        if (!instance) {
            return null;
        }

        if (method && typeof instance[method] === 'function') {
            instance[method]();
        }

        return instance;
    }

    function initComponent(componentName, targets, options, root) {
        const Component = getBootstrap()[componentName];

        if (!Component) {
            return [];
        }

        return resolveElements(targets, root).map(function (element) {
            if (typeof Component.getOrCreateInstance === 'function') {
                return Component.getOrCreateInstance(element, options || {});
            }

            return new Component(element, options || {});
        });
    }

    const api = {
        resolveElement: resolveElement,
        getInstance: getInstance,
        showModal: function (target, options) {
            return call('Modal', target, 'show', options);
        },
        hideModal: function (target, options) {
            return call('Modal', target, 'hide', options);
        },
        toggleModal: function (target, options) {
            return call('Modal', target, 'toggle', options);
        },
        showCollapse: function (target, options) {
            return call('Collapse', target, 'show', options);
        },
        hideCollapse: function (target, options) {
            return call('Collapse', target, 'hide', options);
        },
        toggleCollapse: function (target, options) {
            return call('Collapse', target, 'toggle', options);
        },
        showTab: function (target, options) {
            return call('Tab', target, 'show', options);
        },
        initTooltips: function (targets, options, root) {
            return initComponent('Tooltip', targets || '[data-bs-toggle="tooltip"]', options, root);
        },
        initPopovers: function (targets, options, root) {
            return initComponent('Popover', targets || '[data-bs-toggle="popover"]', options, root);
        },
        dispose: function (componentName, target) {
            const Component = getBootstrap()[componentName];
            const element = resolveElement(target);

            if (!Component || !element || typeof Component.getInstance !== 'function') {
                return false;
            }

            const instance = Component.getInstance(element);

            if (!instance || typeof instance.dispose !== 'function') {
                return false;
            }

            instance.dispose();
            return true;
        },
    };

    window.skmBootstrap = Object.assign(window.skmBootstrap || {}, api);
    document.dispatchEvent(new CustomEvent('skm:bootstrap-native-ready', {
        detail: { api: window.skmBootstrap },
    }));
})();
